import { Button } from "d-react-components";
import { useContext, useState } from "react";
import { BookingCreateContext } from "../../../context/booking";
import Messages from "../../../languages/Messages";
import BookingCrudContactModal from "../common/BookingCrudContactModal";

const BookingCreateContact = () => {
    const [openEdit, setOpenEdit] = useState(false);
    const { bookingForm } = useContext(BookingCreateContext);
    const { contact } = bookingForm.values;
    const { firstName, lastName, phone, email } = contact ?? {};
    return (
        <div className="card-container p-4 mt-3" hidden={!contact}>
            <div className="flex-center justify-content-between">
                <label>{Messages.contact}</label>
                <Button variant="trans" onClick={() => setOpenEdit(true)}>
                    {Messages.edit}
                </Button>
            </div>
            <div className="flex-column">
                <text>{`${firstName} ${lastName}`}</text>
                <text>{email}</text>
                <text>{phone}</text>
            </div>
            {openEdit && (
                <BookingCrudContactModal
                    open={openEdit}
                    onClose={() => setOpenEdit(false)}
                    defaultValue={contact}
                    onChange={(value) =>
                        bookingForm.setFieldValue("contact", value)
                    }
                />
            )}
        </div>
    );
};

export default BookingCreateContact;
